// kapigen version 0.1.33
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { createClient } from "../../requestClientInternal";
var defaultBlobFile = {
    id: 0,
    fileName: "",
    contentLength: 0,
    contentType: "",
    blobUrl: ""
};
export var BlobFileWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBlobFile, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentLength) {
            message.contentLength = parseInt(wireFormat.contentLength);
        }
        return message;
    }
};
export var StartBlobUploadRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.bucket) {
            wireFormat.bucket = ClientBlobBucketWireFormat3.toJson(message.bucket);
        }
        if (message === null || message === void 0 ? void 0 : message.contentLength) {
            wireFormat.contentLength = message.contentLength.toString();
        }
        if (message === null || message === void 0 ? void 0 : message.lastUpdateTime) {
            wireFormat.lastUpdateTime = message.lastUpdateTime.toISOString();
        }
        return wireFormat;
    }
};
var defaultStartBlobUploadResponse = {
    token: "",
    createUrl: ""
};
export var StartBlobUploadResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultStartBlobUploadResponse, wireFormat);
        return message;
    }
};
export var ClientBlobBucket;
(function(ClientBlobBucket) {
    ClientBlobBucket["UNSPECIFIED"] = "unspecified";
    ClientBlobBucket["COMPETITION_DATA_FILES"] = "competitionDataFiles";
    ClientBlobBucket["COMPETITION_SUBMISSIONS"] = "competitionSubmissions";
    ClientBlobBucket["COMPETITION_SOLUTIONS"] = "competitionSolutions";
    ClientBlobBucket["INBOX_FILES"] = "inboxFiles";
    ClientBlobBucket["FORUM_MESSAGE_ATTACHMENT_FILES"] = "forumMessageAttachmentFiles";
    ClientBlobBucket["TEAM_MODEL_FILES"] = "teamModelFiles";
    ClientBlobBucket["USER_CONTENT"] = "userContent";
    ClientBlobBucket["DATASET_VERSION_FILES_V2"] = "datasetVersionFilesV2";
    ClientBlobBucket["KERNEL_SESSION_FILES"] = "kernelSessionFiles";
    ClientBlobBucket["LEARN_CERTIFICATES"] = "learnCertificates";
    ClientBlobBucket["ORGANIZATIONS"] = "organizations";
    ClientBlobBucket["KERNEL_BLOB"] = "kernelBlob";
})(ClientBlobBucket || (ClientBlobBucket = {}));
export var ClientBlobBucketWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ClientBlobBucket.UNSPECIFIED:
            case 0:
            default:
                return "CLIENT_BLOB_BUCKET_UNSPECIFIED";
            case ClientBlobBucket.COMPETITION_DATA_FILES:
            case 1:
                return "COMPETITION_DATA_FILES";
            case ClientBlobBucket.COMPETITION_SUBMISSIONS:
            case 2:
                return "COMPETITION_SUBMISSIONS";
            case ClientBlobBucket.COMPETITION_SOLUTIONS:
            case 3:
                return "COMPETITION_SOLUTIONS";
            case ClientBlobBucket.INBOX_FILES:
            case 4:
                return "INBOX_FILES";
            case ClientBlobBucket.FORUM_MESSAGE_ATTACHMENT_FILES:
            case 5:
                return "FORUM_MESSAGE_ATTACHMENT_FILES";
            case ClientBlobBucket.TEAM_MODEL_FILES:
            case 6:
                return "TEAM_MODEL_FILES";
            case ClientBlobBucket.USER_CONTENT:
            case 7:
                return "USER_CONTENT";
            case ClientBlobBucket.DATASET_VERSION_FILES_V2:
            case 8:
                return "DATASET_VERSION_FILES_V2";
            case ClientBlobBucket.KERNEL_SESSION_FILES:
            case 9:
                return "KERNEL_SESSION_FILES";
            case ClientBlobBucket.LEARN_CERTIFICATES:
            case 10:
                return "LEARN_CERTIFICATES";
            case ClientBlobBucket.ORGANIZATIONS:
            case 11:
                return "ORGANIZATIONS";
            case ClientBlobBucket.KERNEL_BLOB:
            case 12:
                return "KERNEL_BLOB";
        }
    }
};
// Binary Large OBject (BLOB) service used for uploading files to Google Cloud Storage (GCS).
export var blobsClient = {
    blobService: {
        // Starts a blob upload (i.e. reserves a spot for the upload on GCS).
        startBlobUpload: createClient(StartBlobUploadRequestWireFormat3, StartBlobUploadResponseWireFormat3, "blobs.BlobService/StartBlobUpload")
    }
};
